import { useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { errorToast } from 'components/toasts/error';
import { API } from 'configs/api';

export interface CreateVideoReplySignedUrlRequest {
  filename: string;
  filetype: string;
  eridEncoded: string;
  shortUrl: string;
}

export const videoReplySignedUrl = async (
  data: CreateVideoReplySignedUrlRequest
) => {
  const { eridEncoded, shortUrl, ...rest } = data;
  const response: AxiosResponse<{ url: string }> = await API.post(
    `/video-reply/${shortUrl}/erid/${eridEncoded}/signedurl`,
    rest
  );

  return response.data;
};

export const useSignedUrlVideoReplyMutation = () => {
  return useMutation(videoReplySignedUrl, {
    onError: () => {
      errorToast({ title: 'Something went wrong while getting signedurl!' });
    },
  });
};
